import { useEffect, useState } from "react";
import { api } from "@/lib/api";

function Fighter({ f, right }) {
  return (
    <div className={`flex items-center gap-2 min-w-0 flex-1 ${right ? "flex-row-reverse text-right" : ""}`}>
      {f.flag && <img src={f.flag} alt="" className="w-4 h-3 object-cover rounded-sm shrink-0" loading="lazy" />}
      <div className="min-w-0">
        <div className={`text-xs font-bold truncate ${f.winner ? "text-smasher-gold" : "text-slate-300"}`}>{f.name}{f.winner ? " ✓" : ""}</div>
        {f.record && <div className="text-[10px] text-slate-400 font-mono-num">{f.record}</div>}
      </div>
    </div>
  );
}

export function MmaBouts({ card, compact }) {
  return (
    <div className={compact ? "space-y-1" : "grid lg:grid-cols-2 gap-x-6 gap-y-1"} data-testid={`mma-card-${card.id}`}>
      {card.bouts.map((b, i) => (
        <div key={b.id} className={`py-2 border-b border-white/5 last:border-0 ${i === 0 && !compact ? "bg-smasher-gold/5 rounded-lg px-2 lg:col-span-2" : ""}`} data-testid={`mma-bout-${b.id}`}>
          <div className="flex items-center justify-between text-[9px] font-bold tracking-wider mb-1">
            <span className={i === 0 ? "text-smasher-orange" : "text-slate-500"}>{i === 0 ? "MAIN EVENT · " : ""}{(b.weight || "").toUpperCase()}</span>
            {b.result && <span className="text-slate-500 font-mono-num">{b.result}</span>}
          </div>
          <div className="flex items-center gap-2">
            <Fighter f={b.a} />
            <span className="text-[9px] text-slate-600 font-black">VS</span>
            <Fighter f={b.b} right />
          </div>
        </div>
      ))}
    </div>
  );
}

export function useMmaCard(kind, enabled) {
  const [card, setCard] = useState(undefined);
  useEffect(() => {
    if (!enabled || card !== undefined) return;
    api.get("/mma-card", { params: { kind } }).then((r) => setCard(r.data.card)).catch(() => setCard(null));
  }, [kind, enabled, card]);
  return card;
}

export function MmaHeader({ card }) {
  return (
    <div className="mb-2">
      <div className="font-heading font-bold text-white text-sm leading-tight">{card.name}</div>
      <div className="text-[10px] text-slate-500">
        {new Date(card.date).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}
        {card.venue ? ` · ${card.venue}` : ""}{card.city ? `, ${card.city}` : ""}
      </div>
    </div>
  );
}
